/**
 * simple logger implementation
 *
 * @public
 */
export var Logger;
(function (Logger) {
    // tslint:disable-next-line no-any
    Logger.error = (...args) => {
        console.error.apply(undefined, args);
    };
})(Logger || (Logger = {}));
//# sourceMappingURL=Logger.js.map